/*                                                */
/*                                                  */

window.AS = window.AS || {};
window.o_global = window.o_global || {};
window.o_util = window.o_util || {};
window.o_global.pali = window.o_global.pali || {};

function checkPaliObject(initiator: string): void {
  if (Object.keys(window.o_global.pali).length !== 14) {
    window.AS.RUM.sendCustomRequest(`paliErrors`, {
      fields: Object.keys(window.o_global.pali),
      fieldCount: Object.keys(window.o_global.pali).length,
      initiator,
    });
  }
}
window.setTimeout(() => {
  checkPaliObject("inital");
}, 1);

document.addEventListener("DOMContentLoaded", () => {
  checkPaliObject("DOMContentLoaded");
});
